/* eslint-disable no-mixed-spaces-and-tabs */
import React from "react"
import { Card, Icon, List } from "semantic-ui-react"
import AddFeatureToOrgModal from "./AddFeatureToOrgModal"
import RemoveFeatureFromOrgModal from "./RemoveFeatureFromOrgModal"

const BifrostOrgFeaturesComponent = ({ chosenOrg, refreshData, orgDetailsLoading }) => {
	return (
		<Card fluid>
			<Card.Content textAlign="left">
				<Card.Header>
					<Icon name="star" />
					Add-on Features
					<AddFeatureToOrgModal chosenOrg={chosenOrg} refreshOrgDetails={refreshData} orgDetailsLoading={orgDetailsLoading} />
				</Card.Header>
				<Card.Description>
					<List selection animated>
						{chosenOrg.features
							? chosenOrg.features.length === 0
								? "No additional features"
								: chosenOrg.features.map((feature, index) => (
										<List.Item key={index}>
											<List.Content floated="right">
												<RemoveFeatureFromOrgModal feature={feature} org={chosenOrg} refreshData={refreshData} />
											</List.Content>
											<List.Content>
												<List.Header>{feature.name}</List.Header>
											</List.Content>
										</List.Item>
								  ))
							: "No additional features"}
					</List>
				</Card.Description>
			</Card.Content>
		</Card>
	)
}

export default BifrostOrgFeaturesComponent
